import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import styles from "../../../layout/admin/Main.module.scss";
import SearchCondition from "../../../features/SearchCondition";
//コンポーネント
import Button from "../../../ui/Button";
import RadioGroup from "../../../ui/RadioGroup";
import TextField from "../../../ui/TextField";
import Summary from "../../../ui/Summary";
//API
import { getCodeMasterList } from "../../../../services/apiCodeMaster";
/*バリデーション */
import { validateMaxlength } from "../../../../utils/validate";

const controled = 1; //公開状態_公開

const CouseModalSearchFrom = ({ setSearchCondition }) => {
  //ラジオボタン
  // 公開・非公開ラジオボタン
  const [isControlElements, setIsControlElements] = useState([]);
  const [selectedIsControl, setSelectedIsControl] = useState(controled);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  //初回レンダリング
  useEffect(() => {
    (async function () {
      const data = await getCodeMasterList({ code: "CD007" });
      if (!data) return;
      setIsControlElements(
        data.map((d) => {
          return { label: d.d_text, value: d.d_value };
        })
      );
      setValue("control", String(controled));

      setSearchCondition({ control: String(controled) });
    })();
  }, []); //初回レンダリング

  //検索条件リセット
  const resetCondition = () => {
    setValue("id", "");
    setValue("course_name", "");
    setValue("period", ""); //講座開催日・講座時間
    setValue("organ", "");
    setValue("univ_id", "");
    setValue("keyword", ""); //検索キーワード
    setSelectedIsControl(controled);
  };

  const onSubmit = (data) => {
    setSearchCondition(data);
  };

  return (
    <div>
      <details open>
        <Summary />
        <form onSubmit={handleSubmit(onSubmit)}>
          <SearchCondition title="講座を絞り込む">
            <table>
              <tr>
                <TextField
                  register={register}
                  validation={{ ...validateMaxlength(30) }}
                  name="id"
                  errors={errors}
                  label="講座ID"
                  placeholder="講座ID"
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{ ...validateMaxlength(100) }}
                  name="course_name"
                  errors={errors}
                  label="講座名"
                  placeholder="講座名"
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{ ...validateMaxlength(30) }}
                  name="period"
                  errors={errors}
                  label="講座開催日・講座時間"
                  placeholder="講座開催日・講座時間"
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{ ...validateMaxlength(100) }}
                  name="organ"
                  errors={errors}
                  label="実施機関"
                  placeholder="実施機関"
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{ ...validateMaxlength(30) }}
                  name="univ_id"
                  errors={errors}
                  label="大学ID"
                  placeholder="大学ID"
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{ ...validateMaxlength(100) }}
                  name="keyword"
                  errors={errors}
                  label="検索キーワード"
                  placeholder="検索キーワード"
                ></TextField>
              </tr>
              <tr>
                <RadioGroup
                  errors={errors}
                  register={register}
                  label="公開・非公開"
                  name="control"
                  elements={isControlElements}
                  watch={watch}
                  selectedValue={selectedIsControl}
                  setSelectedValue={setSelectedIsControl}
                />
              </tr>
            </table>

            {errors.exampleRequired && <span>This field is required</span>}
          </SearchCondition>
          <div className={styles.buttonbox}>
            <Button type="submit" styleType="search">
              検索
            </Button>
            <Button
              type="button"
              styleType="back"
              onClick={() => resetCondition()}
            >
              条件クリア
            </Button>
          </div>
        </form>
      </details>
    </div>
  );
};

export default CouseModalSearchFrom;
